import { useInterval } from "@vueuse/core"

export function useCountdown(initialSeconds: number) {
	const { counter, reset, pause, resume, isActive } = useInterval(1000, { controls: true, immediate: false })
	const seconds = computed(() => initialSeconds - counter.value)

	watchEffect(() => {
		if (counter.value >= initialSeconds) {
			stop()
		}
	})

	function start() {
		reset()
		resume()
	}

	function stop() {
		pause()
		reset()
	}

	return {
		start,
		stop,
		seconds,
		isCounting: isActive,
	}
}
